import React from 'react';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
function LeagueElement({ value, highlights, position }) {
    var _a, _b;
    const category = ((_a = value.sport) === null || _a === void 0 ? void 0 : _a.slug) || 'competition';
    const href = category === 'football'
        ? `${category}/competitions/${value.id}/${value.slug}/outrights`
        : `${category}/competitions/${value.slug}/outrights`;
    const searchSection = 'Leagues';
    return (React.createElement(SectionItem, { expectedTitle: 1, expectedDescription: 1, cutDescription: 2, internalLink: true, href: href, id: value.id, searchSection: searchSection, position: position },
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.name, content: value.name })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            React.createElement(Highlight, { highlighted: highlights['sport.name'], content: (_b = value.sport) === null || _b === void 0 ? void 0 : _b.name }))));
}
export const LeagueSection = createListSection(LeagueElement, {
    title: 'sectionLeaguesTitle',
});
//# sourceMappingURL=LeagueSection.js.map